import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconPrint = props => (
  <SvgIcon {...props} viewBox="0 0 22 19.9991">
    <path d="m18.7 5.5547h-15.4c-1.826 0-3.3 1.4889-3.3 3.3333v6.6667h4.4v4.4444h13.2v-4.4444h4.4v-6.6667c0-1.8443-1.474-3.3332-3.3-3.3332zm-3.3004 12.224h-8.8v-5.5555h8.8v5.5555zm3.3-7.7786c-0.605 0-1.1-0.5-1.1-1.1111 0-0.61111 0.495-1.1111 1.1-1.1111s1.1 0.5 1.1 1.1111c0 0.61112-0.495 1.1111-1.1 1.1111zm-1.1-10h-13.2v4.4444h13.2v-4.4444z" />
  </SvgIcon>
);

export default IconPrint;



// WEBPACK FOOTER //
// ./src/components/icons/IconPrint.js